import SideMenuCollapseBtn from "@/components/SideMenuCollapseBtn";
import SignOutMenuItem from "@/components/SignOutMenuItem";
import { NAV_ITEM_CLASSES } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useState } from "react";
import { NavLink, useParams } from "react-router-dom";

export default function SideHouseholdMenu() {
  const params = useParams();
  const [isOpen, setIsOpen] = useState(true);

  function toggleMenu() {
    document.getElementsByTagName("body")[0]!.classList.toggle("menu-closed");
    setIsOpen((prev) => !prev);
  }
  const { code } = useAppSelector((state) => state.stock.editStockData);

  return (
    <div className="container-menu flex h-full flex-col justify-between bg-primary pb-[29px] pl-4 pt-4">
      <div className="relative flex h-full w-full flex-col text-sm">
        <NavLink state={true} className={NAV_ITEM_CLASSES} to={`/stock/${params.id}/browse`}>
          {code} Details
        </NavLink>
        <SignOutMenuItem />
      </div>
      <SideMenuCollapseBtn isOpen={isOpen} clickHandler={toggleMenu} />
    </div>
  );
}
